







import { Component, Vue } from 'vue-property-decorator';
import Chart from 'chart.js';
import { billingService } from '@/services/BillingService';

@Component({})
export default class ReportMainChart extends Vue {
  workspaceId = 0;
  periods: any = [];
  chartLabels: any = [];
  chartData: any = [];
  currentCost = 0;
  currency = '';
  chartHandle: any = null;
  getDataHandle: any = null;
  monthName: any = [];
  costLabel = 'cost';
  showReport = false;

  updateChart() {
    if (this.chartHandle) {
      this.chartHandle.destroy();
      this.chartHandle = null;
    }
    clearTimeout(this.getDataHandle);
    this.getDataHandle = setTimeout(() => {
      this.getChart();
    }, 0);
  }

  fixCurrency(currency: string) {
    if (currency === 'PLN') {
      return 'zł';
    }
    if (currency === 'USD') {
      return '$';
    }
    if (currency === 'EUR') {
      return '€';
    }
    return currency;
  }
  fixPrice(price: any, fractionNumber: any = null) {
    price = typeof price !== 'number' ? parseFloat(price) : price;
    let precision = 1 - Math.floor(Math.log(Math.abs(price)) / Math.log(10));
    precision = price > 1 ? 2 : precision;
    const fraction = fractionNumber === null ? (precision < 2 ? 2 : precision) : fractionNumber;
    return price ? price.toFixed(fraction) : 0;
  }
  getCurrentCost(showCurrent: boolean) {
    billingService
      .getCurrentCost(this.workspaceId)
      .then((data: any) => {
        this.currentCost = data.cents;
        if (this.currentCost !== 0 && showCurrent) {
          this.showReport = true;
        }
        this.currency = data.currency;
        this.getMonthLabels();
      })
      .catch(() => {});
  }
  getBillingPeriods() {
    billingService
      .getBillingPeriods(this.workspaceId)
      .then((data: any) => {
        this.periods = data.map((item: any) => {
          const date = item.start_time.split('T')[0];
          item.month = parseInt(date.split('-')[1], 10);
          item.year = parseInt(date.split('-')[0], 10);
          const currentMonth = new Date().getMonth() + 1;
          let showCurrent = true;
          if (item.cost !== 0) {
            this.showReport = true;
          }
          if (item.month === currentMonth) {
            this.showReport = false;
            showCurrent = false;
          }
          this.getCurrentCost(showCurrent);
          return item;
        });
      })
      .catch(() => {});
  }
  getMonthLabels() {
    this.chartLabels = [];
    this.chartData = [];
    for (let i in this.periods) {
      this.chartLabels.push(this.monthName[this.periods[i].month] + ' ' + this.periods[i].year);
      this.chartData.push(this.fixPrice(this.periods[i].cost * 0.01));
    }
    const month = new Date().getMonth() + 1;
    const year = new Date().getFullYear();
    this.chartLabels.push(this.monthName[month] + ' ' + year);
    this.chartData.push(this.fixPrice(this.currentCost * 0.01));
    this.chartData = [...this.chartData];
    this.updateChart();
  }
  getChart() {
    const self = this;
    this.chartHandle = new Chart('mainChart', {
      type: 'bar',
      data: {
        labels: this.chartLabels,
        datasets: [
          {
            label: this.costLabel,
            backgroundColor: 'rgb(92,168,255)',
            borderColor: 'rgb(92,168,255)',
            data: this.chartData,
          },
        ],
      },
      options: {
        animation: {
          duration: 0,
        },
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              display: true,
              ticks: {
                // Include a dollar sign in the ticks
                callback: function(value, index, values) {
                  return (
                    (self.currency !== 'PLN' ? self.fixCurrency(self.currency) : '') +
                    value +
                    (self.currency === 'PLN' ? self.fixCurrency(self.currency) : '')
                  );
                },
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem: any, data: any) {
              return (
                data.datasets[tooltipItem.datasetIndex].label +
                ': ' +
                (self.currency !== 'PLN' ? self.fixCurrency(self.currency) : '') +
                data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] +
                (self.currency === 'PLN' ? self.fixCurrency(self.currency) : '')
              );
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });
  }
  mounted() {
    this.monthName = [
      '',
      this.$t('months.January'),
      this.$t('months.February'),
      this.$t('months.March'),
      this.$t('months.April'),
      this.$t('months.May'),
      this.$t('months.June'),
      this.$t('months.July'),
      this.$t('months.August'),
      this.$t('months.September'),
      this.$t('months.October'),
      this.$t('months.November'),
      this.$t('months.December'),
    ];
    this.costLabel = this.$t('cost') as string;
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.getBillingPeriods();
  }
}
